import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  Paper: {
    boxShadow: theme.shadows[0],
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    fontSize: 14,
    textTransform: 'uppercase',
  },
  btnBox: {
    marginTop: theme.spacing(2),
  },
  btn: {
    padding: theme.spacing(1, 7),
    fontSize: 14,
    textTransform: 'none',
  },
  link: {
    color: '#007dff',
    textTransform: 'none',
  },
}));
